// import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
// import IconButton from '@mui/material/IconButton';
// import CloseIcon from '@mui/icons-material/Close';
import {useState, createContext, useEffect} from 'react';

import * as React from 'react';

import MuiAlert from '@mui/material/Alert';

const context = createContext({});
const Provider = context.Provider;

// severity="error">This is an error message!</Alert>
// <Alert severity="warning">This is a warning message!</Alert>
// <Alert severity="info">This is an information message!</Alert>
// <Alert severity="success"

const settings = {state: false, message: '', type: 'error'};

const Alert = React.forwardRef(function Alert(props, ref,) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

const Services = ({children}) => {

    useEffect(() => {
    }, []);

    const [alertError, setAlertError] = useState(settings);
    const [loader, setLoader] = useState(false);

      const handleClose = () => {  
        setAlertError({...alertError, state: false});
      };

      const alertMessage = (msg, type) => {
        setAlertError({...alertError, state: true, message: msg, type: type});
      }

      const loaderShow = (value = true) =>{
        setLoader(value);
      }

      return (
        <Provider value={{alertMessage, loaderShow}}>
                <Snackbar 
                    open={alertError.state} 
                    autoHideDuration={3000} 
                    anchorOrigin={{ vertical: 'bottom', horizontal:'center'}}
                    onClose={handleClose}>
                        <Alert onClose={handleClose} severity={alertError.type} sx={{ width: '100%' }}>
                            {alertError.message}
                        </Alert>
                </Snackbar>

            {loader ?<div id="loader-spinner" style={{display: loader? 'block': 'none'}}></div>: ''}

            {children}
          </Provider>
        
      )
}

export const ServicesProvider = context;

export default Services;


